@if (authService.hasPermission(Permission.OrganizationsRead)) {
  <button
    mat-icon-button
    matTooltip="Shared with Sky Team"
    matTooltipPosition="above"
    style="margin-right: 8px"
    (click)="onToggle()"
    color="error"
    >
    <mat-icon>{{ isSharedFilter ? "cloud" : "cloud_queue" }}</mat-icon>
  </button>
}
